import { forwardRef, type Ref, type SVGProps } from "react";
const IconMegaphoneOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="m19.975 2.29-1.613.82a1.81 1.81 0 0 0-.79 2.434l.102.201-6.248 5.98-7.942 4.045a2.71 2.71 0 0 0-1.186 3.652l2.465 4.837a2.716 2.716 0 0 0 3.651 1.187l.984-.502 3.507 4.033a2.71 2.71 0 0 0 3.28.635 2.633 2.633 0 0 0 .79-4.07l-.665-.768.149-.482c.15-.452.05-.95-.262-1.31l-.906-1.043 1.064-.541 8.505-1.55.106.209a1.815 1.815 0 0 0 2.434.791l1.613-.82a1.815 1.815 0 0 0 .791-2.433L22.41 3.079a1.81 1.81 0 0 0-2.434-.79m-5.47 22.178a1.35 1.35 0 0 0 .27 1.306l.833.956a.85.85 0 0 1 .183.699.81.81 0 0 1-.429.574.9.9 0 0 1-1.094-.214l-3.21-3.694 2.573-1.31 1.032 1.192zm13.24-5.822a.5.5 0 0 0 .22-.673L21.023 4.349a.5.5 0 0 0-.672-.219l-.72.367a.5.5 0 0 0-.22.672l6.941 13.624a.5.5 0 0 0 .672.22zm-4.049-1.078a.5.5 0 0 1-.356.72l-6.411 1.16a.5.5 0 0 1-.535-.264l-3.158-6.199a.5.5 0 0 1 .1-.588l4.71-4.501a.5.5 0 0 1 .79.134zm-9.074 2.125a.5.5 0 0 1-.219.673l-6.81 3.467a.91.91 0 0 1-1.218-.396L3.91 18.6a.91.91 0 0 1 .396-1.218l6.81-3.47a.5.5 0 0 1 .673.219z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMegaphoneOutlineSVG);
ForwardRef.displayName = "IconMegaphoneOutline";
export { ForwardRef as IconMegaphoneOutline };
